
'use client';

import * as React from 'react';
import { useRouter } from 'next/navigation';
import { AgencyMainContent } from '@/doi-tac-module/components/agency-main-content';
import { AgencySearchModule } from '@/doi-tac-module/components/agency-search-module';
import type { SearchFilters } from '@/doi-tac-module/components/job-search/search-results';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Briefcase, Users } from 'lucide-react';
import { useLanguage } from '@/doi-tac-module/contexts/LanguageContext';
import { agencyTranslations } from '@/doi-tac-module/constants/agency-translations';


export default function AgencyPageClient() {
  const router = useRouter();
  const { language } = useLanguage();
  const t = agencyTranslations;
  const [isChooseDialogOpen, setIsChooseDialogOpen] = React.useState(false);
  const [pendingQuery, setPendingQuery] = React.useState('');

  const handleSearch = (filters: Partial<SearchFilters>) => {
    const params = new URLSearchParams();
    if (filters.visa && filters.visa !== 'all') params.set('loai-visa', filters.visa);
    if (filters.industry && filters.industry !== 'all') params.set('nganh-nghe', filters.industry);
    if (filters.desiredSalaryVietnam && filters.desiredSalaryVietnam !== 'all') params.set('sal_d_max', filters.desiredSalaryVietnam);
    
    setPendingQuery(params.toString());
    setIsChooseDialogOpen(true);
  };

  const handleChooseJob = () => {
    setIsChooseDialogOpen(false);
    router.push(`/doi-tac/viec-lam${pendingQuery ? `?${pendingQuery}` : ''}`);
  };

  const handleChooseCandidate = () => {
    setIsChooseDialogOpen(false);
    router.push(`/doi-tac/ung-vien${pendingQuery ? `?${pendingQuery}` : ''}`);
  };

  const [homeFilters, setHomeFilters] = React.useState<Partial<SearchFilters>>({
    q: '',
    visa: '', 
    visaDetail: '', 
    industry: '', 
    location: [], 
    interviewLocation: '',
  });

  const handleHomeFilterChange = (newFilters: Partial<SearchFilters>) => {
      setHomeFilters(prev => ({...prev, ...newFilters}));
  };

  return (
    <div className="flex flex-col items-center min-h-screen">
        <AgencySearchModule 
            onSearch={handleSearch} 
            filters={homeFilters} 
            onFilterChange={handleHomeFilterChange} 
            showHero={true} 
        />
        <div className="w-full flex-grow">
          <AgencyMainContent />
        </div>

        {/* Popup chọn loại tìm kiếm */}
        <Dialog open={isChooseDialogOpen} onOpenChange={setIsChooseDialogOpen}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader className="text-center">
                    <DialogTitle className="font-headline text-2xl text-center">{t.searchDialog.title[language]}</DialogTitle>
                    <DialogDescription className="text-center">
                        {t.searchDialog.desc[language]}
                    </DialogDescription>
                </DialogHeader>
                <div className="grid grid-cols-2 gap-4 py-2">
                    <button
                        onClick={handleChooseJob}
                        className="flex flex-col items-center justify-center gap-3 p-6 rounded-xl border-2 border-border hover:border-[#FF6921] hover:bg-[#FF6921]/5 transition-all duration-200 cursor-pointer group"
                    >
                        <div className="h-14 w-14 rounded-full bg-orange-100 flex items-center justify-center group-hover:bg-orange-200 transition-colors">
                            <Briefcase className="h-7 w-7 text-[#FF6921]" />
                        </div>
                        <p className="font-bold text-base">{t.searchDialog.findJob[language]}</p>
                    </button>
                    <button
                        onClick={handleChooseCandidate}
                        className="flex flex-col items-center justify-center gap-3 p-6 rounded-xl border-2 border-border hover:border-[#F2B92A] hover:bg-yellow-50 transition-all duration-200 cursor-pointer group"
                    >
                        <div className="h-14 w-14 rounded-full bg-yellow-100 flex items-center justify-center group-hover:bg-yellow-200 transition-colors">
                            <Users className="h-7 w-7 text-[#F2B92A]" />
                        </div>
                        <p className="font-bold text-base">{t.searchDialog.findCandidate[language]}</p>
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    </div>
  );
}
